<template>
  <v-content>
    <v-layout class="justify-center">
      <v-flex xs12>
        <v-card flat>
          <loading
            loader="dots"
            color="#FD5246"
            :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="false"
          ></loading>

          <v-sheet
            style="background-color: #F8F7F7;"
            class="mx-auto"
            max-width="100%"
          >
            <v-slide-group
              show-arrows
              center-active
              class="slide-group"
              style="height: 50px;"
            >
              <v-slide-item
                v-model="model"
                v-for="(category_collection, i) in category_collections"
                :key="i"
              >
                <v-btn
                  v-if="
                    category_collection.collections_count != 0 ||
                      category_collection.id === 0
                  "
                  class="mx-1"
                  :style="
                    collection_id === category_collection.id
                      ? {
                          'background-color': '#FD5246',
                          color: '#FFFFFF',
                          height: '40px',
                        }
                      : {
                          'background-color': '#9C9C9C',
                          color: '#FFFFFF',
                          height: '40px',
                        }
                  "
                  @click.native="onClickCollection(category_collection.id)"
                >
                  <span style="font-size: 12px">
                    {{
                      switchLanguage === "th"
                        ? category_collection.category_collection_name_th
                        : category_collection.category_collection_name_en
                    }}
                  </span>
                  <span
                    v-if="category_collection.id !== 0"
                    class="ml-2"
                    style="font-size: 12px"
                  >
                    {{ category_collection.collections_count }}
                  </span>
                  <span v-else class="ml-2" style="font-size: 12px">
                    {{ category_collection.collections_count }}
                  </span>
                </v-btn>
              </v-slide-item>
            </v-slide-group>
          </v-sheet>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <pre>
      {{category_collections}}
    </pre> -->

    <loading
      color="#FD5246"
      :active.sync="isLoadingScreen"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
  </v-content>
</template>

<script>
import { mapState } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "SlideGroup",
  props: {
    onClickCollection: Function,
  },
  components: {
    Loading,
  },
  data: () => ({
    isLoading: false,
    isLoadingScreen: false,
    fullPage: true,
    model: null,
    nameUrl: "CuratedDebut",
    category_collections: [],
  }),
  watch: {
    model: function() {},
  },
  computed: {
    ...mapState({
      collection_id: (state) => {
        return state.Collection.collection_id;
      },
      collections: (state) => {
        return state.Collection.collections;
      },
      // category_collections: state => {
      //     return state.Collection.category_collections;
      // },
      collections_by_id: (state) => {
        return state.Collection.collections_by_id;
      },
      switchLanguage: (state) => {
        return state.Common.switchLanguage;
      },
    }),
  },
  created() {
    this.getCategoryCollection();
  },
  methods: {
    getCategoryCollection() {
      this.isLoading = true;
      this.$store.dispatch("Collection/getCategoryCollection").then((res) => {
        this.category_collections = res.data;
        this.isLoading = false;
      });
    },
    getCollectionById(val) {
      let data = { id: val, page: 1, custom_paginate: 0 };
      this.isLoadingScreen = true;
      this.$store
        .dispatch("Collection/getCollectionById", data)
        .then((res) => {
          this.isLoadingScreen = false;
          if (this.$route.name !== "Creator") {
            this.$router.push("/creator");
          }
        })
        .catch((err) => {
          this.isLoadingScreen = false;
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
.color-toggle {
  background-color: rgb(253, 82, 70) !important;
  border-bottom-right-radius: unset !important;
  border-bottom-left-radius: unset !important;
}
button.mx-1.btn-slide.v-btn.v-btn--contained.theme--light.v-size--default {
  border-bottom-right-radius: unset !important;
  border-bottom-left-radius: unset !important;
}
.slide-group .v-slide-group__content {
  align-items: flex-end;
}
.v-btn:not(.v-btn--round).v-size--default {
  /*padding-top: 0;*/
  /*padding-right: 10px!important;*/
  /*padding-bottom: 0;*/
  /*padding-left: 10px!important;*/
}
</style>
